/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const RotateLeftStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M8.5 6H12C16.142 6 19.5 9.358 19.5 13.5C19.5 17.642 16.142 21 12 21C7.858 21 4.5 17.642 4.5 13.5M8.5 6L11.5 3M8.5 6L11.5 9"
          strokeLinecap="round"
        />
      </svg>
    </Icon>
  );
});

export { RotateLeftStrokeIcon };
